<template>
  <div class="mi-card">
    <div class="mi-title">Informasi Keanggotaan</div>

    <div class="mi-grid">
      <!-- Item 1 -->
      <button class="mi-item" type="button" @click="$emit('click-documents')">
        <div class="mi-icon">
          <img src="../assets/icons/folder_open.svg" alt=""/>
        </div>
        <div class="mi-label">Dokumen Partai</div>
      </button>

      <!-- Item 2 -->
      <button class="mi-item" type="button" @click="$emit('click-aspirasi')">
        <div class="mi-icon">
          <img src="../assets/icons/file_edit.svg" alt=""/>
        </div>
        <div class="mi-label">Aspirasi</div>
      </button>

      <!-- Item 3 -->
      <button class="mi-item" type="button" @click="$emit('click-laporan')">
        <div class="mi-icon">
          <img src="../assets/icons/file_plus.svg" alt=""/>
        </div>
        <div class="mi-label">Laporan Kegiatan</div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipInfoCard'
}
</script>

<style scoped>
.mi-card {
  width: 100%;
  background: #ffffff;
  border: 1px solid #eef2ff;
  border-radius: 16px;
  padding: 16px;
}

.mi-title {
  font-weight: 800;
  color: #374151;
  font-size: 16px;
  margin-bottom: 14px;
}

.mi-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.mi-item {
  width: 100%;
  border: 1px solid #e7ecff;
  border-radius: 14px;
  background: #ffffff;
  padding: 18px 12px;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  appearance: none;
  outline: none;
}

@media (hover: hover) {
  .mi-item:hover {
    border-color: #cfd8ff;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
  }
}

.mi-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1f4db8;
}

.mi-label {
  font-weight: 700;
  color: #374151;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 600px) {
  .mi-card {
    padding: 14px;
    border-radius: 14px;
  }

  .mi-grid {
    grid-template-columns: 1fr;
  }

  .mi-item {
    flex-direction: row;
    justify-content: flex-start;
    padding: 14px 12px;
  }

  .mi-label {
    text-align: left;
  }
}
</style>
